/**
 * Shared recipe type constants for the Crafting arche UI.
 */

export const RECIPE_TYPE_LABELS: Record<string, string> = {
  grid: 'Grid',
  litland: 'Litland',
  business: 'Business',
  pet_breed: 'Pet Breed',
  pet_modify: 'Pet Modify',
  chest_open: 'Chest Open',
  tool_upgrade: 'Tool Upgrade',
  recipe_learn: 'Recipe Learn',
  base_pet: 'Base Pet',
  grass_convert: 'Grass Convert',
  artifact: 'Artifact',
};

/** Recipe type options with value/label pairs (for Select and Tabs components) */
export const RECIPE_TYPE_OPTIONS = Object.entries(RECIPE_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

/** Recipe type values as a flat array (for RecipeForm select) */
export const RECIPE_TYPE_VALUES = Object.keys(RECIPE_TYPE_LABELS);
